import React from 'react';

const PortfolioSummary = ({ portfolio, formatCurrency }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8">
      {/* Cash Balance — true account value */}
      <div className="bg-gray-800 rounded-lg p-4 md:p-6 relative">
        <h3 className="text-sm md:text-lg font-semibold mb-2 text-blue-400">Cash Balance</h3>
        <p data-testid="cash-balance" className="text-lg md:text-2xl font-bold">
          {portfolio?.loading ? "Loading..." : 
           portfolio?.cash !== undefined ? formatCurrency(portfolio.cash) : formatCurrency(0)}
        </p>
        {portfolio?.isStale && portfolio?.lastUpdated && (
          <div className="absolute top-2 right-2 bg-yellow-600 text-yellow-100 text-xs px-2 py-1 rounded flex items-center gap-1" title="Data may be outdated">
            {Math.round((Date.now() - portfolio.lastUpdated) / 60000)}m ago
          </div>
        )}
      </div>
      
      {/* Total Value */}
      <div className="bg-gray-800 rounded-lg p-4 md:p-6 relative">
        <h3 className="text-sm md:text-lg font-semibold mb-2 text-green-400">Total Value</h3>
        <p data-testid="total-value" className="text-lg md:text-2xl font-bold">
          {portfolio?.loading ? "Loading..." : 
           portfolio?.total_value !== null ? formatCurrency(portfolio?.total_value || 0) : formatCurrency(0)}
        </p>
      </div>
      
      {/* Current P&L */}
      <div className="bg-gray-800 rounded-lg p-4 md:p-6">
        <h3 className="text-sm md:text-lg font-semibold mb-2 text-yellow-400">Current P&L</h3>
        <p className={`text-lg md:text-2xl font-bold ${portfolio && (portfolio.daily_pnl || 0) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
          {portfolio?.loading ? "Loading..." : 
           portfolio?.daily_pnl !== null ? formatCurrency(portfolio?.daily_pnl || 0) : formatCurrency(0)}
        </p>
        {!portfolio?.loading && portfolio?.margin_used > 0 && (
          <div className="mt-1 flex items-center gap-2 text-xs md:text-sm">
            <span className={`font-semibold ${(portfolio.daily_pnl || 0) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
              {((portfolio.daily_pnl / portfolio.margin_used) * 100).toFixed(2)}%
            </span>
            {portfolio.positions?.length === 1 && (
              <span className="bg-gray-700 px-1.5 py-0.5 rounded text-gray-300">
                {portfolio.positions[0].leverage}x
              </span>
            )}
          </div>
        )}
      </div>
      
      {/* Positions Count */}
      <div className="bg-gray-800 rounded-lg p-4 md:p-6">
        <h3 className="text-sm md:text-lg font-semibold mb-2 text-purple-400">Positions</h3>
        <p className="text-lg md:text-2xl font-bold">
          {portfolio?.loading ? "Loading..." : 
           portfolio?.positions ? portfolio.positions.length : 0}
        </p>
      </div>
    </div>
  );
};

export default PortfolioSummary;
